import { DotLottieReact } from "@lottiefiles/dotlottie-react";

function LoadingAnimation({ width, height }) {
  return (
    <div
      style={{
        width: width || "300px",
        height: height || "300px",
        margin: "0 auto",
      }}
    >
      <DotLottieReact
        src="https://lottie.host/90da935e-6fe1-4d0b-a8d6-4c3f2894cdf4/wAvDwMnplK.lottie"
        loop
        autoplay
      />
    </div>
  );
}

export default LoadingAnimation;
